import { ReactElement } from "react";
import { padWithLeadingZeros } from "../app/utils/string";

export const CodeLock = (params: { code: number }): ReactElement => {
  /*const rotations = [
    36*(params.code)/1000,
    36*(params.code)/100,
    36*(params.code)/10,
    36*(params.code)
  ]*/
  const rotations = [
    36 * Math.floor(params.code / 1000),
    36 * Math.floor(params.code / 100),
    36 * Math.floor(params.code / 10),
    36 * params.code
  ]
  return (
    <div className={'lock__wrap'}>
      <div className={'lock'}>
        <div className="wheel" style={{ transform: "rotateY(0deg) translateX(0px)", zIndex: 0 }}>
          <div className="wheel__inner"
               style={{ transform: "rotateX(" + rotations[0] + "deg)" }}>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(0deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>0</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(36deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>9</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(72deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>8</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(108deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>7</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(144deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>6</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(180deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>5</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(216deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>4</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(252deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>3</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(288deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>2</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(325deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>1</span>
            </div>
          </div>
        </div>
        <div className="wheel" style={{ transform: "rotateY(0deg) translateX(0px)", zIndex: 0 }}>
          <div className="wheel__inner"
               style={{ transform: "rotateX(" + rotations[1] + "deg)" }}>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(0deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>0</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(36deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>9</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(72deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>8</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(108deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>7</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(144deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>6</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(180deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>5</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(216deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>4</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(252deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>3</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(288deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>2</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(325deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>1</span>
            </div>
          </div>
        </div>
        <div className="wheel" style={{ transform: "rotateY(0deg) translateX(0px)", zIndex: 0 }}>
          <div className="wheel__inner"
               style={{ transform: "rotateX(" + rotations[2] + "deg)" }}>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(0deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>0</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(36deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>9</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(72deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>8</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(108deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>7</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(144deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>6</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(180deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>5</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(216deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>4</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(252deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>3</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(288deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>2</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(325deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>1</span>
            </div>
          </div>
        </div>
        <div className="wheel" style={{ transform: "rotateY(0deg) translateX(0px)", zIndex: 0 }}>
          <div className="wheel__inner"
               style={{ transform: "rotateX(" + rotations[3] + "deg)" }}>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(0deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>0</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(36deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>9</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(72deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>8</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(108deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>7</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(144deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>6</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(180deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>5</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(216deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>4</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(252deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>3</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(288deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>2</span>
            </div>
            <div className="wheel__segment"
                 style={{ transform: "rotateX(325deg) translateZ(calc(var(--elementHeight) * 1.564102564102564 * 1)" }}>
              <span>1</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}